import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { ref: "chatinput" };
const _hoisted_2 = { class: "col-12 self-end" };
const _hoisted_3 = { class: "col-12 self-end" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { for: "uploadimg" };
const _hoisted_6 = { class: "cursor-pointer" };
const _hoisted_7 = { for: "uploadfile" };
const _hoisted_8 = { class: "cursor-pointer" };
const _hoisted_9 = { class: "cursor-pointer" };
const _hoisted_10 = { class: "cursor-pointer" };
const _hoisted_11 = { class: "cursor-pointer" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_input = _resolveComponent("q-input");
    const _component_stacked_icon = _resolveComponent("stacked-icon");
    const _component_file_check_input = _resolveComponent("file-check-input");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_popup_proxy = _resolveComponent("q-popup-proxy");
    const _component_emoji = _resolveComponent("emoji");
    const _component_share_listing = _resolveComponent("share-listing");
    const _component_listing_video = _resolveComponent("listing-video");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_input, {
            class: "chat-input",
            dark: _ctx.dark || _ctx.$q.dark.isActive,
            dense: "",
            filled: "",
            "model-value": _ctx.text,
            "onUpdate:modelValue": _ctx.setVal,
            placeholder: "Message",
            type: "textarea",
            ref: "message",
            rows: "1",
            id: "chat-input",
            onFocus: _ctx.focus,
            onBlur: _ctx.blur,
            onKeydown: _ctx.checkSend
        }, {
            prepend: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_q_btn, {
                        flat: "",
                        round: "",
                        name: "Show Emoji",
                        color: "grey-6",
                        icon: "get-icon-emoji-emotions",
                        dense: "",
                        onClick: _ctx.showEmoji
                    }, null, 8, ["onClick"])
                ])
            ]),
            append: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                    (!_ctx.hideAttach)
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 0,
                            name: "add",
                            class: "cursor-pointer q-mr-md",
                            size: "sm",
                            round: "",
                            onClick: _ctx.showMore,
                            onMousedown: _ctx.preventer
                        }, null, 8, ["onClick", "onMousedown"]))
                        : _createCommentVNode("", true),
                    _createVNode(_component_q_icon, {
                        name: "send",
                        class: "cursor-pointer self-center",
                        size: "sm",
                        round: "",
                        color: _ctx.btnColor,
                        onClick: _ctx.send,
                        onMousedown: _ctx.preventer
                    }, null, 8, ["color", "onClick", "onMousedown"])
                ])
            ]),
            _: 1
        }, 8, ["dark", "model-value", "onUpdate:modelValue", "onFocus", "onBlur", "onKeydown"]),
        _createVNode(_component_q_popup_proxy, {
            modelValue: _ctx.showUpload,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.showUpload) = $event)),
            "no-parent-event": "",
            breakpoint: 320,
            ref: "upload-height",
            class: _normalizeClass({
                'full-width': _ctx.styleType !== 'desktop',
                'st-min-wh-320': _ctx.styleType === 'desktop'
            })
        }, {
            default: _withCtx(() => [
                _createVNode(_component_q_card, {
                    style: {
                        height: '249px'
                    },
                    flat: ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "q-pa-sm" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass({
                                            ..._ctx.shareClass
                                        })
                                    }, [
                                        _createElementVNode("label", _hoisted_5, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createVNode(_component_stacked_icon, {
                                                    "circle-color": "primary",
                                                    icon: "insert_photo",
                                                    "circle-size": 50,
                                                    "icon-size": "30px"
                                                }),
                                                _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                                                    _createElementVNode("span", { class: "text-caption" }, "Images")
                                                ], -1))
                                            ])
                                        ]),
                                        _createVNode(_component_file_check_input, {
                                            ref: "imgFormRef",
                                            id: "uploadimg",
                                            accept: "image/*",
                                            onFileUpdate: _ctx.emitUploadImg
                                        }, null, 8, ["onFileUpdate"])
                                    ], 2),
                                    _createElementVNode("div", {
                                        class: _normalizeClass({
                                            ..._ctx.shareClass
                                        })
                                    }, [
                                        _createElementVNode("label", _hoisted_7, [
                                            _createElementVNode("div", _hoisted_8, [
                                                _createVNode(_component_stacked_icon, {
                                                    "circle-color": "grey-6",
                                                    icon: "description",
                                                    "circle-size": 50,
                                                    "icon-size": "30px"
                                                }),
                                                _cache[9] || (_cache[9] = _createElementVNode("div", null, [
                                                    _createElementVNode("span", { class: "text-caption" }, "Files")
                                                ], -1))
                                            ])
                                        ]),
                                        _createVNode(_component_file_check_input, {
                                            ref: "fileFormRef",
                                            id: "uploadfile",
                                            accept: "image/*,video/*,.pdf,.xls,.xlsx,.ppt,.pptx,.doc,.docx",
                                            onFileUpdate: _ctx.emitUploadFile
                                        }, null, 8, ["onFileUpdate"])
                                    ], 2),
                                    (!_ctx.isChatUser && (_ctx.appType === 'getspaces') && !_ctx.listingLoading)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: _normalizeClass({
                                                ..._ctx.shareClass
                                            }),
                                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('custom-order')))
                                        }, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _createVNode(_component_stacked_icon, {
                                                    "circle-color": "positive",
                                                    icon: "add_shopping_cart",
                                                    "circle-size": 50,
                                                    "icon-size": "30px"
                                                }),
                                                _cache[10] || (_cache[10] = _createElementVNode("div", null, [
                                                    _createElementVNode("span", { class: "text-caption" }, "Custom Order")
                                                ], -1))
                                            ])
                                        ], 2))
                                        : _createCommentVNode("", true),
                                    ((_ctx.otherListingCount > 0) && !_ctx.isChatUser)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: _normalizeClass({
                                                ..._ctx.shareClass
                                            }),
                                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.showListingShare = true))
                                        }, [
                                            _createElementVNode("div", _hoisted_10, [
                                                _createVNode(_component_stacked_icon, {
                                                    "circle-color": "orange-8",
                                                    icon: "location_city",
                                                    "circle-size": 50,
                                                    "icon-size": "30px"
                                                }),
                                                _cache[11] || (_cache[11] = _createElementVNode("div", null, [
                                                    _createElementVNode("span", { class: "text-caption" }, "Share Space")
                                                ], -1))
                                            ])
                                        ], 2))
                                        : _createCommentVNode("", true),
                                    ((_ctx.videoCount > 0) && !_ctx.isChatUser)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 2,
                                            class: _normalizeClass({
                                                ..._ctx.shareClass
                                            }),
                                            onClick: _cache[2] || (_cache[2] =
                                                //@ts-ignore
                                                (...args) => (_ctx.showVideoListClick && _ctx.showVideoListClick(...args)))
                                        }, [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createVNode(_component_stacked_icon, {
                                                    "circle-color": "accent",
                                                    icon: "play_circle",
                                                    "circle-size": 50,
                                                    "icon-size": "30px"
                                                }),
                                                _cache[12] || (_cache[12] = _createElementVNode("div", null, [
                                                    _createElementVNode("span", { class: "text-caption" }, "Space Video")
                                                ], -1))
                                            ])
                                        ], 2))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ]),
            _: 1
        }, 8, ["modelValue", "class"]),
        _createVNode(_component_q_popup_proxy, {
            modelValue: _ctx.showing,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.showing) = $event)),
            "no-parent-event": "",
            ref: "emoji-height",
            breakpoint: 320
        }, {
            default: _withCtx(() => [
                _createVNode(_component_emoji, { onAddEmoji: _ctx.parseEmoji }, null, 8, ["onAddEmoji"])
            ]),
            _: 1
        }, 8, ["modelValue"]),
        (!_ctx.isChatUser && _ctx.listing)
            ? (_openBlock(), _createBlock(_component_share_listing, {
                key: 0,
                show: _ctx.showListingShare,
                "onUpdate:show": _cache[5] || (_cache[5] = ($event) => ((_ctx.showListingShare) = $event)),
                receiver: _ctx.receiver,
                listing: _ctx.listing.id,
                onListingShared: _cache[6] || (_cache[6] = ($event) => (_ctx.showUpload = false))
            }, null, 8, ["show", "receiver", "listing"]))
            : _createCommentVNode("", true),
        (!_ctx.isChatUser && _ctx.listing)
            ? (_openBlock(), _createBlock(_component_listing_video, {
                key: 1,
                ref: "videoRef",
                listing: _ctx.listing,
                receiver: _ctx.receiver,
                "app-type": _ctx.appType === 'getspaces'
                    ? 'getspaces'
                    : 'getproperty',
                onVideoSent: _cache[7] || (_cache[7] = ($event) => (_ctx.showUpload = false))
            }, null, 8, ["listing", "receiver", "app-type"]))
            : _createCommentVNode("", true)
    ], 512));
}
